/* RANI CUSTOM — Loox carousel otomatik kayma
   Her N saniyede bir Loox carousel'ın "next" ok butonunu programatik tıklatır.
   Loox'un kendi DOM/Shadow yapısı zaman zaman değişebilir, bu yüzden çok geniş
   class adı arama yapıyoruz. Bulunan ilk uygun next-button kullanılır. */
(function () {
  'use strict';

  var INTERVAL_MS = 5000;          // her 5 sn ileri
  var PAUSE_ON_HOVER = true;
  var SCAN_DELAY = 1000;           // sayfa yüklendikten sonra Loox'un render etmesini bekle
  var hovered = false;

  function findNextButton() {
    // Olası selectorler — Loox sürümüne göre değişebilir
    var candidates = [
      '.loox-carousel-arrow-next',
      '.loox-next, .loox-arrow-next',
      '[class*="loox"][class*="next"]',
      '[class*="loox"] button[aria-label*="Next"]',
      '[class*="loox"] button[aria-label*="next"]',
      '[class*="loox"] button[aria-label*="İleri"]',
      '[class*="loox"] [class*="arrow"][class*="next"]',
      '[class*="loox"] [class*="-right"]',
      '[class*="carousel"][class*="loox"] [class*="next"]',
      '[id*="loox"] button[aria-label*="Next"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.offsetParent !== null && !el.disabled) return el;
    }
    return null;
  }

  function findContainer() {
    var sel = [
      '.loox-carousels-container',
      '[class*="loox-carousel"]',
      '[id*="loox"][class*="carousel"]',
      'shopify-section[id*="apps"]:has([class*="loox"])'
    ];
    for (var i = 0; i < sel.length; i++) {
      try {
        var el = document.querySelector(sel[i]);
        if (el) return el;
      } catch (e) { /* :has yoksa sessiz geç */ }
    }
    return null;
  }

  function bindHover() {
    if (!PAUSE_ON_HOVER) return;
    var c = findContainer();
    if (!c) return;
    c.addEventListener('mouseenter', function () { hovered = true; });
    c.addEventListener('mouseleave', function () { hovered = false; });
    c.addEventListener('touchstart', function () { hovered = true; setTimeout(function () { hovered = false; }, 4000); }, { passive: true });
  }

  function tick() {
    if (hovered) return;
    if (document.hidden) return;
    var btn = findNextButton();
    if (!btn) return;
    // doğal click event
    btn.click();
  }

  function start() {
    bindHover();
    setInterval(tick, INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, SCAN_DELAY); });
  } else {
    setTimeout(start, SCAN_DELAY);
  }
})();
